module.exports = {
          srcSet: __webpack_public_path__ + "f472c3344928438708bc2f012123e964-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "f472c3344928438708bc2f012123e964-24.png",width: 24,height: 24}],
          src: __webpack_public_path__ + "f472c3344928438708bc2f012123e964-24.png",
          toString:function(){return __webpack_public_path__ + "f472c3344928438708bc2f012123e964-24.png"},
          
          width: 24,
          height: 24
        }